import { render, staticRenderFns } from "./EditTutor.vue?vue&type=template&id=47f1238e&scoped=true"
import script from "./EditTutor.vue?vue&type=script&lang=js"
export * from "./EditTutor.vue?vue&type=script&lang=js"
import style0 from "./EditTutor.vue?vue&type=style&index=0&id=47f1238e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f1238e",
  null
  
)

export default component.exports